var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBatteryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 28,
    viewBox: "0 0 48 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 26H6C4.93913 26 3.92172 25.5786 3.17157 24.8285C2.42143 24.0783 2 23.0609 2 22V6.00003C2 4.93916 2.42143 3.92175 3.17157 3.1716C3.92172 2.42146 4.93913 2.00003 6 2.00003H12.38M30 2.00003H34C35.0609 2.00003 36.0783 2.42146 36.8284 3.1716C37.5786 3.92175 38 4.93916 38 6.00003V22C38 23.0609 37.5786 24.0783 36.8284 24.8285C36.0783 25.5786 35.0609 26 34 26H27.62M46 16V12M22 2.00003L14 14H26L18 26",
    stroke: "#07587F",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatteryIcon);
export default __webpack_public_path__ + "static/media/BatteryIcon.329fbcbee42aa4fde6049fdeca79973b.svg";
export { ForwardRef as ReactComponent };